import React from 'react';

// Small shared building blocks for the vendor portal.

export const VpSpinner = () => <div className='vp-spinner' />;

export const VpEmpty = ({
	icon = '📭',
	text = 'Nothing here yet.',
}: {
	icon?: string;
	text?: string;
}) => (
	<div className='vp-empty'>
		<div className='vp-empty-icon'>{icon}</div>
		<div>{text}</div>
	</div>
);

export const VpStatusBadge = ({ status }: { status?: string }) => {
	const s = (status || '').toLowerCase();
	let cls = 'vp-badge-neutral';
	let label = status || '—';
	if (s === 'confirmed') {
		cls = 'vp-badge-confirmed';
		label = 'Accepted';
	} else if (s === 'rejected') {
		cls = 'vp-badge-rejected';
		label = 'Rejected';
	} else if (s === 'pending') {
		cls = 'vp-badge-pending';
		label = 'Pending';
	}
	return <span className={`vp-badge ${cls}`}>{label}</span>;
};

export const VpStat = ({
	icon,
	value,
	label,
	tint = 'primary',
}: {
	icon: string;
	value: React.ReactNode;
	label: string;
	tint?: 'primary' | 'success' | 'warning' | 'danger' | 'info';
}) => (
	<div className='vp-stat'>
		<div className='vp-stat-top'>
			<div className='vp-stat-value'>{value}</div>
			<div className={`vp-stat-icon vp-tint-${tint}`}>{icon}</div>
		</div>
		<div className='vp-stat-label'>{label}</div>
	</div>
);

export const VpConfirmModal = ({
	open,
	emoji = '⚠️',
	title,
	message,
	confirmText = 'Confirm',
	cancelText = 'Cancel',
	loading = false,
	onConfirm,
	onCancel,
}: {
	open: boolean;
	emoji?: string;
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	loading?: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}) => {
	if (!open) return null;
	return (
		<div className='vp-modal-backdrop' onClick={onCancel}>
			<div className='vp-modal' onClick={(e) => e.stopPropagation()}>
				<div className='vp-modal-emoji'>{emoji}</div>
				<h3>{title}</h3>
				<p>{message}</p>
				<div className='vp-modal-actions'>
					<button
						type='button'
						className='vp-btn vp-btn-ghost'
						onClick={onCancel}
						disabled={loading}>
						{cancelText}
					</button>
					<button
						type='button'
						className='vp-btn vp-btn-primary'
						onClick={onConfirm}
						disabled={loading}>
						{loading ? 'Please wait…' : confirmText}
					</button>
				</div>
			</div>
		</div>
	);
};

export const money = (n: any) => {
	const v = Number(n || 0);
	return `₹${v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const fmtDate = (d: any) => {
	if (!d) return '—';
	try {
		return new Date(d).toLocaleDateString('en-IN', {
			day: '2-digit',
			month: 'short',
			year: 'numeric',
		});
	} catch {
		return '—';
	}
};
